import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    $onChanges() {
        this.init();
    }

    $onInit() {
        this.init();
        this.watch();
    }

    init() {
        this.$settings = this.mobileApplicationSettings;
        this.settings = {...this.$settings};
    }

    notModified() {
        return angular.equals(this.$settings, this.settings);
    }

    onKeyUp($event) {
        if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
            this.onEnter();
        }
    }

    watch() {
        this.$scope.$watch(
            () => this.settings,
            () => this.onChange({$value: this.settings, $invalid: this.form.$invalid}),
            true
        );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/mobile-app-support/mobile-app-support-form.controller.js